export default __webpack_public_path__ + "static/media/medicine.c8c03c20.png";